module.exports = "/static/assets/3e3e5f8a22c80c09294ebfc9559ceeac.png";